<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click="(dialogAdd = true)"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog
            v-model="dialogAdd"
            persistent
            :max-width="resCol === '12' ? '' : '40%'"
            :fullscreen="resCol === '12' ? true : false"
          >
            <v-card v-if="session.data.shopId !== 'SD_1737957295593'">
              <v-form ref="form" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top: 15px; padding-bottom: 15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>สร้างแพ็กเกจ</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click="clearData()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="11" class="v-margit_text_add">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formAdd.pictureUrlPreview"
                              v-if="formAdd.pictureUrlPreview"
                            ></v-img>
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.required]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImg"
                              v-model="filesAdd"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packageName"
                              label="ชื่อแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-select
                              v-model="formAdd.limitPackage"
                              :items="itemLimitPackage"
                              label="จำกัดการซื้อแพ็กเกจ"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packageCount"
                              label="จำนวนครั้งที่ใช้ได้"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packagePrice"
                              label="ราคาแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packagePoint"
                              label="คะแนนที่ได้หลังจากซื้อแพ็กเกจ"
                              outlined
                              hide-details
                              dense
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-select
                              v-model="formAdd.packageExpri"
                              :items="itemExpri"
                              label="วันหมดอายุของแพ็กเกจ"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" style="height: 65px">
                            <v-select
                              v-model="formAdd.startExpireAfterFirstUse"
                              :items="typeExpire"
                              label="เริ่มนับวันวันหมดอายุของแพ็กเกจ"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="session.data.shopId === 'U57de59022f079434e724afc24dd8b50a' || session.data.shopId === 'U46b17db406ee6976c058cb98486957c4' || session.data.shopId === 'U84bee5c35d25a597a87e85e0b3029330' ||  session.data.shopId === 'U4581148094e2790fedc0cc1fa2ef755c'">
                          <v-col cols="12" style="height: 65px">
                            <v-select
                              v-model="formAdd.useInBranch"
                              :items="branchLoyalty"
                              item-text="masBranchName"
                              item-value="masBranchID"
                              label="สาขาที่สามารถใช้ได้"
                              multiple
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" style="height: auto">
                            <v-select
                              v-model="formAdd.flowId"
                              :items="itemLinked"
                              label="ประเภทบริการ"
                              chips
                              small-chips
                              multiple
                              outlined
                              dense
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="formAdd.flowId && Array.isArray(formAdd.flowId) && formAdd.flowId.filter(id => id !== '' && id !== 'None').length > 0">
                          <v-col cols="12" class="py-0">
                            <v-checkbox
                              v-model="formAdd.isCashCoupon"
                              label="ใช้คูปองแทนเงินสด"
                              :true-value="'True'"
                              :false-value="'False'"
                              hide-details
                            ></v-checkbox>
                            <p class="caption grey--text mt-1 ml-8">
                              หมายเหตุ: หากเปิดใช้งาน จะไม่ทำการชำระนัดหมายของ Be Linked
                            </p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="formAdd.packageDetail"
                              outlined
                              name="input-7-4"
                              label="รายละเอียดของแพ็กเกจ"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row style="padding-bottom: 15px">
                          <v-col cols="12">
                            <v-btn
                              elevation="2"
                              large
                              block
                              dark
                              color="#173053"
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
            <v-card v-else>
              <v-form ref="form" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top: 15px; padding-bottom: 15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>สร้างแพ็กเกจ</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click="clearData()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="11" class="v-margit_text_add">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formAdd.pictureUrlPreview"
                              v-if="formAdd.pictureUrlPreview"
                            ></v-img>
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.required]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImg"
                              v-model="filesAdd"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packageName"
                              label="ชื่อแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-select
                              v-model="formAdd.limitPackage"
                              :items="itemLimitPackage"
                              label="จำกัดการซื้อแพ็กเกจ"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packageCount"
                              label="จำนวนครั้งที่ใช้ได้"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packagePrice"
                              label="ราคาแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formAdd.packagePoint"
                              label="คะแนนที่ได้หลังจากซื้อแพ็กเกจ"
                              outlined
                              hide-details
                              dense
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-select
                              v-model="formAdd.packageExpri"
                              :items="itemExpri"
                              label="วันหมดอายุของแพ็กเกจ"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" style="height: 65px">
                            <v-select
                              v-model="formAdd.startExpireAfterFirstUse"
                              :items="typeExpire"
                              label="เริ่มนับวันวันหมดอายุของแพ็กเกจ"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="session.data.shopId === 'U57de59022f079434e724afc24dd8b50a' || session.data.shopId === 'U46b17db406ee6976c058cb98486957c4' || session.data.shopId === 'U84bee5c35d25a597a87e85e0b3029330' ||  session.data.shopId === 'U4581148094e2790fedc0cc1fa2ef755c'">
                          <v-col cols="12" style="height: 65px">
                            <v-select
                              v-model="formAdd.useInBranch"
                              :items="branchLoyalty"
                              item-text="masBranchName"
                              item-value="masBranchID"
                              label="สาขาที่สามารถใช้ได้"
                              multiple
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" style="height: auto">
                            <v-select
                              v-model="formAdd.flowId"
                              :items="itemLinked"
                              label="ประเภทบริการ"
                              chips
                              small-chips
                              multiple
                              outlined
                              dense
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="formAdd.flowId && Array.isArray(formAdd.flowId) && formAdd.flowId.filter(id => id !== '' && id !== 'None').length > 0">
                          <v-col cols="12" class="py-0">
                            <v-checkbox
                              v-model="formAdd.isCashCoupon"
                              label="ใช้คูปองแทนเงินสด"
                              :true-value="'True'"
                              :false-value="'False'"
                              hide-details
                            ></v-checkbox>
                            <p class="caption grey--text mt-1 ml-8">
                              หมายเหตุ: หากเปิดใช้งาน จะไม่ทำการชำระนัดหมายของ Be Linked
                            </p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="formAdd.packageDetail"
                              outlined
                              name="input-7-4"
                              label="รายละเอียดของแพ็กเกจ"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row style="padding-bottom: 15px">
                          <v-col cols="12">
                            <v-btn
                              elevation="2"
                              large
                              block
                              dark
                              color="#173053"
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog
            v-model="dialogEdit"
            persistent
            :max-width="resCol === '12' ? '' : '40%'"
            :fullscreen="resCol === '12' ? true : false"
          >
            <v-card v-if="session.data.shopId !== 'SD_1737957295593'">
              <v-form ref="form" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top: 15px; padding-bottom: 15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>แก้ไขแพ็กเกจ</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click="(dialogEdit = false), clearDataUpdate()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="11" class="v-margit_text_add">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formUpdate.pictureUrlPreview"
                              v-if="formUpdate.pictureUrlPreview"
                            ></v-img>
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.required]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImgUpdate"
                              v-model="filesUpdate"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packageName"
                              label="ชื่อแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packageCount"
                              label="จำนวนครั้งที่ใช้ได้"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packagePrice"
                              label="ราคาแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packagePoint"
                              label="คะแนนที่ได้หลังจากซื้อแพ็กเกจ"
                              outlined
                              dense
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-select
                              v-model="formUpdate.packageExpri"
                              :items="itemExpri"
                              label="วันหมดอายุของแพ็กเกจ"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" style="height: 65px">
                            <v-select
                              v-model="formUpdate.startExpireAfterFirstUse"
                              :items="typeExpire"
                              readonly
                              label="เริ่มนับวันวันหมดอายุของแพ็กเกจ"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="session.data.shopId === 'U57de59022f079434e724afc24dd8b50a' || session.data.shopId === 'U46b17db406ee6976c058cb98486957c4' || session.data.shopId === 'U84bee5c35d25a597a87e85e0b3029330' ||  session.data.shopId === 'U4581148094e2790fedc0cc1fa2ef755c'">
                          <v-col cols="12" style="height: 65px">
                            <v-select
                              v-model="formUpdate.useInBranch"
                              :items="branchLoyalty"
                              item-text="masBranchName"
                              item-value="masBranchID"
                              label="สาขาที่สามารถใช้ได้"
                              multiple
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" style="height: 65px">
                            <v-select
                              v-model="formUpdate.limitPackage"
                              :items="itemLimitPackage"
                              label="จำกัดการซื้อแพ็กเกจ"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                          <v-col
                            cols="12"
                            style="height: auto"
                            v-if="itemLinked.length > 0"
                          >
                            <v-select
                              v-model="formUpdate.flowId"
                              :items="itemLinked"
                              label="ประเภทบริการ"
                              chips
                              small-chips
                              multiple
                              outlined
                              dense
                              :rules="[rules.required]"
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="formUpdate.flowId && Array.isArray(formUpdate.flowId) && formUpdate.flowId.filter(id => id !== '' && id !== 'None').length > 0">
                          <v-col cols="12" class="py-0">
                            <v-checkbox
                              v-model="formUpdate.isCashCoupon"
                              label="ใช้คูปองแทนเงินสด"
                              :true-value="'True'"
                              :false-value="'False'"
                              hide-details
                            ></v-checkbox>
                            <p class="caption grey--text mt-1 ml-8">
                              หมายเหตุ: หากเปิดใช้งาน จะไม่ทำการชำระนัดหมายของ Be Linked
                            </p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="formUpdate.packageDetail"
                              outlined
                              name="input-7-4"
                              label="รายละเอียดของแพ็กเกจ"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row style="padding-bottom: 15px">
                          <v-col cols="12">
                            <v-btn
                              elevation="2"
                              large
                              block
                              dark
                              color="#173053"
                              :loading="loadingEdit"
                              @click="editData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
            <v-card v-else>
              <v-form ref="form" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top: 15px; padding-bottom: 15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>แก้ไขแพ็กเกจ</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click="(dialogEdit = false), clearDataUpdate()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="11" class="v-margit_text_add">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formUpdate.pictureUrlPreview"
                              v-if="formUpdate.pictureUrlPreview"
                            ></v-img>
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.required]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImgUpdate"
                              v-model="filesUpdate"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packageName"
                              label="ชื่อแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-select
                              v-model="formUpdate.limitPackage"
                              :items="itemLimitPackage"
                              label="จำกัดการซื้อแพ็กเกจ"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packagePrice"
                              label="ราคาแพ็กเกจ"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" style="height: 65px">
                            <v-text-field
                              v-model="formUpdate.packagePoint"
                              label="คะแนนที่ได้หลังจากซื้อแพ็กเกจ"
                              outlined
                              dense
                              type="number"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            style="height: auto"
                          >
                            <v-select
                              v-model="formUpdate.listReward"
                              :items="reward"
                              item-text="name"
                              item-value="rewardId"
                              label="เลือกของรางวัลที่ต้องการแจก"
                              multiple
                              chips
                              hide-details
                              outlined
                            >
                            </v-select>
                          </v-col>
                          <v-col cols="12" class="py-0" style="height: 40px;display: flex;align-items: center;">
                            <v-checkbox
                              v-model="formUpdate.giveRewardStatus"
                              :label="`แพ็กเกจนี้เพิ่มของรางวัลครบแล้ว`"
                              on-icon="mdi-checkbox-marked-circle"
                              off-icon="mdi-checkbox-blank-circle-outline"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row v-if="formUpdate.flowId && Array.isArray(formUpdate.flowId) && formUpdate.flowId.filter(id => id !== '' && id !== 'None').length > 0">
                          <v-col cols="12" class="py-0">
                            <v-checkbox
                              v-model="formUpdate.isCashCoupon"
                              label="ใช้คูปองแทนเงินสด"
                              :true-value="'True'"
                              :false-value="'False'"
                              hide-details
                            ></v-checkbox>
                            <p class="caption grey--text mt-1 ml-8">
                              หมายเหตุ: หากเปิดใช้งาน จะไม่ทำการชำระนัดหมายของ Be Linked
                            </p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="formUpdate.packageDetail"
                              outlined
                              name="input-7-4"
                              label="รายละเอียดของแพ็กเกจ"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row style="padding-bottom: 15px">
                          <v-col cols="12">
                            <v-btn
                              elevation="2"
                              large
                              block
                              dark
                              color="#173053"
                              :loading="loadingEdit"
                              @click="editData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              บันทึก
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="ชื่อแพ็กเกจ"
                        outlined
                        dense
                        v-model="formUpdate.packageName"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="formUpdate.packageCount"
                        label="จำนวน"
                        dense
                        outlined
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <v-dialog
            v-model="dialogViewAdd"
            persistent
            max-width="30%"
            :fullscreen="resCol === '12'"
          >
            <v-card style="max-height: 690px; overflow-x: hidden">
              <v-card-text>
                <v-container>
                  <v-row style="padding-top: 0">
                    <v-col style="padding: 15px 16px 0px"> </v-col>
                    <v-col class="text-right">
                      <v-btn
                        small
                        fab
                        color="#E0E0E0"
                        @click="(dialogAdd = false), (dialogViewAdd = false)"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="text-center"
                      style="
                        justify-content: center;
                        display: flex;
                        padding: 0px 15px;
                      "
                    >
                      <v-img
                        class="my-auto"
                        :src="session.data.logo"
                        max-width="80"
                      ></v-img>
                    </v-col>
                    <v-col
                      cols="12"
                      style="justify-content: center; display: flex"
                    >
                      <span class="my-auto shopname">{{
                        session.data.name
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-divider
                    color="#FFA000"
                    style="margin-bottom: 10px"
                  ></v-divider>
                  <v-row>
                    <v-col>
                      <p>
                        หมายเหตุ : QR CODE สามารถใช้ได้แค่ครั้งเดียวเท่านั้น
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center">
                      <qrcode-vue
                        style="margin-top: 10px"
                        :value="veiwQRCode.qrCodeURL"
                        size="150"
                        level="H"
                      ></qrcode-vue>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-3 pb-0 text-center">
                      <h2>{{ veiwQRCode.packageName }}</h2>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center">
                      <h3 style="font-size: 18.72px">
                        จำนวน {{ veiwQRCode.packageCount }} ครั้ง
                      </h3>
                    </v-col>
                  </v-row>
                  <v-divider color="#C4C4C4"></v-divider>
                  <v-row>
                    <v-col class="pt-3 pb-0">
                      <h2>ราคาแพ็กเกจ</h2>
                    </v-col>
                    <v-col class="text-right">
                      <h2>
                        {{ formatNumber(veiwQRCode.packagePrice) }}
                        บาท
                      </h2>
                    </v-col>
                  </v-row>
                  <v-row
                    style="margin-top: 1px"
                    v-if="veiwQRCode.packagePoint > 0"
                  >
                    <v-col class="text-right">
                      <h2>+ {{ veiwQRCode.packagePoint }} คะแนน</h2>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogSelectBranch" max-width="600px" persistent>
            <v-card class="py-4">
              <v-card-text>
                <v-container class="pa-5">
                  <v-row>
                    <v-col cols="12" style="padding-bottom: 0">
                      <v-select
                        v-model="selectBranch"
                        :items="Branch"
                        item-value="masBranchID"
                        item-text="masBranchName"
                        label="กรุณเลือกสาขา"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions style="justify-content: center; padding-top: 0">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-btn
                      color="green"
                      style="color: white"
                      block
                      @click="createPackageAndAddbranch()"
                      :disabled="selectBranch === null"
                    >
                      สร้าง Qrcode แพ็กเกจ
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="red"
                      style="color: white"
                      block
                      @click="
                        (selectBranch = null), (dialogSelectBranch = false)
                      "
                    >
                      ปิด
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogSelectMemberSell"
            persistent
            :max-width="resCol === '12' ? '' : '40%'"
            :fullscreen="resCol === '12' ? true : false"
          >
            <v-card>
              <v-form ref="form" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <h2 style="padding-bottom: 10px">
                      ขายแพ็กเกจแบบเลือกลูกค้า
                    </h2>
                    <v-row>
                      <v-col
                        cols="12"
                        class="pt-0 pb-0"
                        style="padding-bottom: 0"
                      >
                        <p style="margin-bottom: 2px">
                          เบอร์โทรศัพท์<span style="color: red">*</span>
                        </p>
                        <v-text-field
                          v-model="tel_member"
                          outlined
                          dense
                          :v-mask="session.data.shopId !== shopNameData.SHOP_ID_CHUBB? '###-###-####' : null"
                          @input="checkTel"
                          :rules="nameRules"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        class="pt-0 pb-0"
                        style="padding-bottom: 0"
                        v-if="dataPK.flowId"
                      >
                        <p style="margin-bottom: 2px">
                          สาขา<span style="color: red">*</span>
                        </p>
                        <v-select
                          v-model="selectBranch"
                          :items="Branch"
                          label="กรุณเลือกสาขา"
                          required
                          outlined
                          dense
                          item-value="masBranchID"
                          item-text="masBranchName"
                          :rules="nameRules"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-container>
                          <v-sheet color="" width="100%">
                            <v-row ustify="start">
                              <v-col cols="3">
                                <v-avatar color="primary" size="100">
                                  <img
                                    :src="
                                      !foundItem || foundItem.length === 0
                                        ? 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
                                        : foundItem.picture
                                    "
                                  />
                                </v-avatar>
                              </v-col>
                              <v-col cols="4">
                                <h2 class="custom-text">
                                  {{
                                    !foundItem || foundItem.length === 0
                                      ? "ชื่อไลน์"
                                      : foundItem.name
                                  }}
                                </h2>
                                <h4>
                                  ไอดี :
                                  {{
                                    !foundItem || foundItem.length === 0
                                      ? "-"
                                      : foundItem.memberId
                                  }}
                                </h4>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-container class="pt-0">
                              <v-row justify="start">
                                <v-col cols="4" class="">
                                  <h4 style="color: rgb(147 142 142)">
                                    แพ็กเกจที่ต้องการซื้อ
                                  </h4>
                                </v-col>
                                <v-col cols="4" class="">
                                  <h4 style="color: rgb(147 142 142)">
                                    {{ dataPK ? dataPK.packageName : "-" }}
                                  </h4>
                                </v-col>
                              </v-row>
                              <v-row justify="start">
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">ราคา</h4>
                                </v-col>
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">
                                    {{
                                      dataPK
                                        ? dataPK.packagePrice + " " + "บาท"
                                        : "-"
                                    }}
                                  </h4>
                                </v-col>
                              </v-row>
                              <v-row justify="start" v-if="dataPK.useInBranch && dataPK.useInBranch !== '' && dataPK.useInBranch !== 'None' && dataPK.useInBranch.length > 0">
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">สาขาที่สามารถใช้แพ็กเกจได้</h4>
                                </v-col>
                                <v-col cols="8" class="pt-0 d-flex" style="flex-wrap: wrap;">
                                  <v-chip style="color: rgb(147 142 142)" v-for="(item, i) in dataPK.useInBranch" :key="i">
                                        {{item}}
                                  </v-chip>
                                </v-col>
                              </v-row>
                              <v-row justify="start">
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">
                                    จำนวนครั้งที่ใช้ได้
                                  </h4>
                                </v-col>
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">
                                    {{
                                      dataPK
                                        ? dataPK.packageCount + " " + "ครั้ง"
                                        : "-"
                                    }}
                                  </h4>
                                </v-col>
                              </v-row>
                              <v-row justify="start">
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">
                                    คะแนนที่ได้หลังจากการซื้อ
                                  </h4>
                                </v-col>
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">
                                    {{
                                      dataPK
                                        ? dataPK.packagePoint + " " + "คะแนน"
                                        : "-"
                                    }}
                                  </h4>
                                </v-col>
                              </v-row>
                              <v-row justify="start">
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">
                                    วันหมดอายุ
                                  </h4>
                                </v-col>
                                <v-col cols="4" class="pt-0">
                                  <h4 style="color: rgb(147 142 142)">
                                    {{ dataPK ? dataPK.packageExpridate : "-" }}
                                  </h4>
                                </v-col>
                              </v-row>

                              <v-divider
                                style="padding-bottom: 13px"
                              ></v-divider>
                              <v-row>
                                <v-col class="pt-0">
                                  <v-btn block color="error" @click="cancle()"
                                    >ยกเลิก</v-btn
                                  >
                                </v-col>
                                <v-col cols="" class="pt-0">
                                  <v-btn
                                    dark
                                    block
                                    color="#1b437c"
                                    :loading="loading"
                                    @click.stop="session.data.shopId !== shopNameData.SHOP_ID_CHUBB? submit() : submitLmg()"
                                    >ยืนยัน</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-sheet>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="1" v-if="dataReady" style="border-radius: 5px">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.packagePrice`]="{ item }">
                    {{ formatNumber(item.packagePrice) }}
                  </template>
                  <template v-slot:[`item.packageExpri`]="{ item }">
                    {{ item.packageExpri }}
                  </template>
                  <template v-slot:[`item.packageImg`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.packageImg" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.packagePoint`]="{ item }">
                    {{ item.packagePoint !== ' ' && item.packagePoint && item.packagePoint > 0 ? item.packagePoint : '-'  }}
                  </template>
                  <template v-slot:[`item.packageDetail`]="{ item }">
                    {{ item.packageDetail !== ' ' && item.packageDetail ? item.packageDetail : '-'  }}
                  </template>
                  <template v-slot:[`item.packageCount`]="{ item }">
                    {{ item.packageCount !== ' ' && item.packageCount ? item.packageCount : '-'  }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="session.data.shopId !== 'SD_1737957295593'"
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          @click.stop="
                            (dialogView = true),
                              getDataById(item),
                              createPackage(item)
                          "
                        >
                          <v-icon dark> mdi-sale </v-icon>
                        </v-btn>
                      </template>
                      <span>ขายแพ็กเกจ</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="session.data.shopId !== 'SD_1737957295593'"
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          @click.stop="
                            (dialogSelectMemberSell = true),
                              getBranch(),
                              dataPackage(item)
                          "
                        >
                          <v-icon dark> mdi-package </v-icon>
                        </v-btn>
                      </template>
                      <span>ขายแพ็กเกจแบบเลือกลูกค้า</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          @click.stop="getDataById(item, 'edit')"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="getDataById(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
// import constants from '../../constants.js'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import { VueEditor } from 'vue2-editor'
import VuetifyMoney from '../VuetifyMoney.vue'
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VueEditor,
    VuetifyMoney,
    QrcodeVue
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  watch: {
    'formAdd.flowId' (val) {
      if (Array.isArray(val) && val.filter(id => id !== '' && id !== 'None').length === 0) {
        this.formAdd.isCashCoupon = 'False'
      }
    },
    'formUpdate.flowId' (val) {
      if (Array.isArray(val) && val.filter(id => id !== '' && id !== 'None').length === 0) {
        this.formUpdate.isCashCoupon = 'False'
      }
    }
  },
  data () {
    return {
      PK: '',
      path: '/package/', // Path Model
      PATH: '/packageQRcode/',
      returnLink: '/Master/Package',
      Branch: [],
      selectBranch: null,
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการแพ็กเกจ',
          disabled: false,
          href: '/Master/Package'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // Dialog Config ADD EDIT DELETE IMPORT
      menu1: false,
      menu2: false,
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogViewAdd: false,
      dialogSelectMemberSell: false,
      session: this.$session.getAll(),
      dialogSelectBranch: false,
      // Search All
      searchAll: '',
      dialogAdd์Notify: false,
      searchAll2: '',
      filesAdd: null,
      filesUpdate: null,
      nowDate: new Date().toISOString().slice(0, 10),
      formAdd: {
        packageImg: '',
        packageName: '',
        packageCount: '',
        packagePrice: '',
        packagePoint: '',
        packageExpri: '',
        packageDetail: '',
        limitPackage: 'false',
        isCashCoupon: 'False',
        flowId: [],
        useInBranch: '',
        CREATE_USER: '',
        LAST_USER: '',
        // pictureUrlPreview: '',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        packageId: '',
        packageImg: '',
        packageName: '',
        packageCount: '',
        packagePrice: '',
        packagePoint: '',
        packageExpri: '',
        packageDetail: '',
        useInBranch: '',
        limitPackage: '',
        isCashCoupon: 'False',
        flowId: [],
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrlPreview: '',
        startExpireAfterFirstUse: '',
        shopId: ''
      },
      createQRcodePackage: {
        packageId: '',
        chkQRCode: 1,
        token: '',
        liffId: '',
        status: 'waiting',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        masBranchID: '',
        CREATE_DATE: ''
      },
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },

      rules: {
        required: (value) => !!value || 'กรุณากรอก.'
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'ชื่อแพ็กเกจ', value: 'packageName' },
        { text: 'จำนวนครั้งที่ใช้ได้', value: 'packageCount' },
        { text: 'ราคาแพ็กเกจ', value: 'packagePrice' },
        { text: 'คะแนนที่ได้หลังจากซื้อแพ็กเกจ', value: 'packagePoint' },
        { text: 'รายละเอียดของแพ็กเกจ', value: 'packageDetail' },
        { text: 'วันหมดอายุของแพ็กเกจ', value: 'packageExpridate' },
        { text: 'จัดการ', value: 'action', sortable: false }
      ],
      itemExpri: [
        { text: '1 เดือน', value: '1' },
        { text: '2 เดือน', value: '2' },
        { text: '3 เดือน', value: '3' },
        { text: '4 เดือน', value: '4' },
        { text: '5 เดือน', value: '5' },
        { text: '6 เดือน', value: '6' },
        { text: '7 เดือน', value: '7' },
        { text: '8 เดือน', value: '8' },
        { text: '9 เดือน', value: '9' },
        { text: '10 เดือน', value: '10' },
        { text: '11 เดือน', value: '11' },
        { text: '1 ปี', value: '12' }
      ],
      typeExpire: [
        { text: 'เริ่มนับวันหมดอายุหลังจากซื้อแพ็กเกจ', value: 'False' },
        { text: 'เริ่มนับวันหมดอายุหลังจากใช้แพ็กเกจครั้งแรก', value: 'True' }
      ],
      branchLoyalty: [],
      mapDataBranch: {},
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      dataLevel: [],
      ProductExchangeRate: [],
      listNewReward: null,
      // End Data Table Config
      dataBranch: [],
      itemLinked: [],
      loadingAdd: false,
      loadingEdit: false,
      veiwQRCode: {},
      oldListReward: [],
      itemBranch: null,
      liffId: '',
      reward: null,
      isDifferent: null,
      itemLimitPackage: [
        { text: 'ไม่จำกัด', value: 'false' },
        { text: 'จำกัด 1 แพ็กเกจ/ท่าน', value: 'true' }
      ],
      tel_member: '',
      lastCheckedTel: '',
      dataPK: {},
      loading: false,
      foundItem: [],
      nameRules: [(v) => !!v || 'กรุณากรอก']
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    console.log('document.body.scrollHeight', document.body.scrollHeight)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    await this.getFlowLinked()
    await this.getData()
    await this.getProductExchangeRate()
    await this.getBranch()
    await this.LinkPackage()
    if (this.session.data.shopId === 'SD_1737957295593') {
      await this.Reward()
    }
  },
  methods: {
    async Reward () {
      await axios
        .get(
          this.DNS_IP + '/reward/get?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.reward = null
          } else {
            if (this.session.data.shopId !== 'SD_1737957295593') {
              this.reward = res.data.filter((item) => {
                return item.quotaCode > 0
              })
            } else {
              this.reward = res.data
            }
          }
        })
      console.log('reawrdddd', this.reward)
    },
    LinkPackage () {
      axios
        .get(
          'https://api-belinked.betaskthai.tech/lineconfig/get?shopId=' +
            this.session.data.shopId
        )
        .then((res) => {
          if (res.data.status === false) {
            this.liffId = '1656906322-JN5MM8Ep'
          } else {
            if (res.data.liffMainIDLoyalty === null) {
              this.liffId = '1656906322-JN5MM8E'
            } else {
              this.liffId = res.data[0].liffMainIDLoyalty
            }
          }
        })
    },
    validate () {
      this.$refs.form.validate()
    },
    getFlowLinked () {
      axios
        .get(
          'https://api-belinked.betaskthai.tech/flow/get?shopId=' +
            // 'Ucb91b5fb61ff0c01e6d7d4c5f7962c57'
            //   +
            this.session.data.shopId
          //     http://localhost:8081/ConditionFlow?shopId=Ucb91b5fb61ff0c01e6d7d4c5f7962c57&flowId=45
        )
        .then((response) => {
          let rs = response.data
          rs.map((el) =>
            this.itemLinked.push({
              value: el.flowId.toString(),
              text: el.flowName
            })
          )
        })
    },
    getData () {
      console.log(this.dataItem)
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.packageExpri !== '') {
          if (d.packageExpri === '12') {
            d.packageExpridate = '1 ปี'
            this.dataItem.push(d)
          } else {
            d.packageExpridate = d.packageExpri + ' เดือน'
            this.dataItem.push(d)
          }
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    },
    selectImgUpdate () {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg () {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    checkBelink () {
      console.log('test')
    },
    createPackageAndAddbranch () {
      this.LinkPackage()
      console.log('this.selectBranch', this.selectBranch)
      let idbranch = null
      idbranch = this.selectBranch
      this.dataShowQR = false
      this.$swal({
        title: 'ต้องการสร้างQR CODE ให้ลูกค้าใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          // this.loadingAdd = true
          this.createQRcodePackage.packageId = this.formUpdate.packageId
          this.createQRcodePackage.CREATE_USER = this.session.data.userName
          this.createQRcodePackage.LAST_USER = this.session.data.userName
          this.createQRcodePackage.liffId = this.liffId
          this.createQRcodePackage.masBranchID = idbranch
          this.createQRcodePackage.shopId = this.$session.getAll().data.shopId
          //   this.createQRcodePackage.masBranchID = this.$session.getAll().data.shopId
          this.createQRcodePackage.qrCodeURL = `https://liff.line.me/${this.liffId}/packageQRcode?shopId=${this.createQRcodePackage.shopId}&packageToken=${this.createQRcodePackage.Token}`
          // console.log('this.formAdd.qrCodeURL', this.formAdd.qrCodeURL)
          delete this.createQRcodePackage['CREATE_DATE']
          console.log('createQRcodePackage', this.createQRcodePackage)
          await axios
            .post(this.DNS_IP + this.PATH + 'add', this.createQRcodePackage)
            .then(async (response) => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              await axios
                .get(
                  this.DNS_IP +
                    '/packageQRcode/get?shopId=' +
                    this.session.data.shopId +
                    '&token=' +
                    response.data.token
                )
                .then((response) => {
                  let res = response.data[0]
                  console.log('res', res)
                  Object.assign(this.veiwQRCode, res)
                  console.log('assign', this.veiwQRCode)
                })
              //   this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.formAdd.CREATE_DATE = new Date().toISOString().substr(0, 10)
              this.dialogViewAdd = true
              // this.loadingAdd = false
            })
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
      console.log('packageId', this.$session.getAll().data)
      this.selectBranch = null
    },
    createPackage (item) {
      this.LinkPackage()

      if (item.flowId !== null && item.flowId !== '') {
        this.dialogSelectBranch = true
      }
      if (item.flowId === null || item.flowId === '') {
        this.dataShowQR = false
        this.$swal({
          title: 'ต้องการสร้างQR CODE ให้ลูกค้าใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async (result) => {
            // this.loadingAdd = true;
            this.createQRcodePackage.packageId = this.formUpdate.packageId
            this.createQRcodePackage.CREATE_USER = this.session.data.userName
            this.createQRcodePackage.LAST_USER = this.session.data.userName
            this.createQRcodePackage.liffId = this.liffId
            this.createQRcodePackage.masBranchID = this.selectBranch
            this.createQRcodePackage.shopId = this.$session.getAll().data.shopId
            this.createQRcodePackage.qrCodeURL = `https://liff.line.me/${this.liffId}/packageQRcode?shopId=${this.createQRcodePackage.shopId}&packageToken=${this.createQRcodePackage.Token}`
            delete this.createQRcodePackage['CREATE_DATE']
            await axios
              .post(this.DNS_IP + this.PATH + 'add', this.createQRcodePackage)
              .then(async (response) => {
                console.log('addDataGlobal DNS_IP + PATH + "add"', response)
                await axios
                  .get(
                    this.DNS_IP +
                      '/packageQRcode/get?shopId=' +
                      this.session.data.shopId +
                      '&token=' +
                      response.data.token
                  )
                  .then((response) => {
                    let res = response.data[0]
                    Object.assign(this.veiwQRCode, res)
                  })
                this.formAdd.CREATE_DATE = new Date()
                  .toISOString()
                  .substr(0, 10)
                this.dialogViewAdd = true
              })
              .catch((error) => {
                console.log('error function addDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
                this.dataReady = true
              })
          })
          .catch((error) => {
            console.log('error function addData : ', error)
            this.dataReady = true
          })
      }
    },
    async getDataById (item, type) {
      console.log(item)
      this.dataReady = true
      Object.assign(this.formUpdate, item)
      this.formUpdate.pictureUrlPreview = this.formUpdate.packageImg
      if (this.formUpdate.packageExpri === '') {
        this.formUpdate.packageExpri = ''
      } else {
        this.formUpdate.packageExpri = this.formUpdate.packageExpri
      }
      if (this.formUpdate.packageExchange === '') {
        this.formUpdate.packageExchange = ''
      } else {
        this.formUpdate.packageExchange = this.formUpdate.packageExchange
      }
      if (this.formUpdate.useInBranch && this.formUpdate.useInBranch !== 'None' && this.formUpdate.useInBranch !== '') {
        this.formUpdate.useInBranch = JSON.parse(this.formUpdate.useInBranch)
      } else if (this.formUpdate.useInBranch === 'None' || this.formUpdate.useInBranch === '') {
        this.formUpdate.useInBranch = null
      }
      if (this.formUpdate.listReward && this.formUpdate.listReward !== 'None' && this.formUpdate.listReward !== '') {
        this.formUpdate.listReward = JSON.parse(this.formUpdate.listReward)
        this.oldListReward = this.formUpdate.listReward
      } else if (this.formUpdate.listReward === 'None' || this.formUpdate.listReward === '') {
        this.formUpdate.listReward = []
        this.oldListReward = []
      }
      if (this.formUpdate.giveRewardStatus) {
        this.formUpdate.giveRewardStatus = this.formUpdate.giveRewardStatus.toLowerCase() === 'true'
      }
      if (item.flowId === null) {
        item.flowId = 'None'
      }
      console.log('flowID_sprit', item.flowId.split(','))
      this.formUpdate.flowId = item.flowId.split(',')

      if (type === 'edit') {
        this.dialogEdit = true
        // this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      }
    },
    async getProductExchangeRate () {
      this.ProductExchangeRate = []
      await axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId.toString()
            s.text = d.name
            d = s
            console.log(d)
            this.ProductExchangeRate.push(d)
          }
          console.log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async addData () {
      this.$refs.form.validate()
      if (this.$refs.form.validate() === true) {
        this.formAdd.flowId = this.formAdd.flowId.toString()
        console.log(this.formAdd.flowId)
        console.log(this.formAdd)
        if (this.session.data.shopId === 'SD_1737957295593') {
          this.dataReady = false
          this.$swal({
            title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
          }).then(async (result) => {
            this.loadingAdd = true
            this.formAdd.CREATE_USER = this.session.data.userName
            this.formAdd.LAST_USER = this.session.data.userName
            // this.formAdd.flowId = this.formAdd.flowId.join(',')

            const _this = this
            let params = new FormData()
            params.append('file', this.filesAdd)
            if (this.formAdd.listReward && this.formAdd.listReward !== '') {
              console.log('this.formAdd.listReward', this.formAdd.listReward)
              this.formAdd.listReward.sort((a, b) => a - b)
              this.formAdd.listReward = this.formAdd.listReward !== '' ? JSON.stringify(this.formAdd.listReward) : this.formAdd.listReward
            }

            await axios
              .post(this.DNS_IP + `/file/upload/package`, params)
              .then(function (response) {
                _this.formAdd.packageImg = response.data
                console.log('url Pic', response.data)
              })
            delete this.formAdd['pictureUrlPreview']
            await axios
              .post(this.DNS_IP + this.path + 'add', this.formAdd)
              .then(async (response) => {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.dialogAdd = false
                this.loadingAdd = false
                await this.clearData()
                //   this.filesAdd = null
                await this.getDataGlobal(
                  this.DNS_IP,
                  this.path,
                  this.session.data.shopId,
                  this.returnLink
                )
                await this.getData()
              })
              .catch((error) => {
                console.log('error function addDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
                this.dataReady = true
              })
          })
            .catch((error) => {
              console.log('error function addData : ', error)
              this.dataReady = true
            })
        } else {
          this.dataReady = false
          this.$swal({
            title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
          })
            .then(async (result) => {
              this.loadingAdd = true
              this.formAdd.CREATE_USER = this.session.data.userName
              this.formAdd.LAST_USER = this.session.data.userName
              // this.formAdd.flowId = this.formAdd.flowId.join(',')

              const _this = this
              let params = new FormData()
              params.append('file', this.filesAdd)
              if (this.formAdd.useInBranch) {
                this.formAdd.useInBranch = this.formAdd.useInBranch !== '' ? JSON.stringify(this.formAdd.useInBranch) : this.formAdd.useInBranch
              }
              // if (this.formAdd.useInBranch) {
              //   this.formAdd.useInBranch !== '' ? JSON.stringify(this.formAdd.useInBranch) : this.formAdd.useInBranch
              // }
              // console.log('params', params)

              await axios
                .post(this.DNS_IP + `/file/upload/package`, params)
                .then(function (response) {
                  _this.formAdd.packageImg = response.data
                  console.log('url Pic', response.data)
                })
              delete this.formAdd['pictureUrlPreview']
              await axios
                .post(this.DNS_IP + this.path + 'add', this.formAdd)
                .then(async (response) => {
                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                  this.dialogAdd = false
                  this.loadingAdd = false
                  await this.clearData()
                  //   this.filesAdd = null
                  await this.getDataGlobal(
                    this.DNS_IP,
                    this.path,
                    this.session.data.shopId,
                    this.returnLink
                  )
                  await this.getData()
                })
                .catch((error) => {
                  console.log('error function addDataGlobal : ', error)
                  this.$router.push(
                    '/system/Errorpage?returnLink=' + this.returnLink
                  )
                  this.dataReady = true
                })
            })
            .catch((error) => {
              console.log('error function addData : ', error)
              this.dataReady = true
            })
        }
      }
    },
    async editData () {
      this.dataReady = false
      console.log('update', this.formUpdate)
      if (this.session.data.shopId === 'SD_1737957295593') {
        if (this.oldListReward && this.formUpdate.listReward) {
          if (this.oldListReward.length > 0 && this.formUpdate.listReward.length > 0) {
            try {
              this.isDifferent = JSON.stringify(this.oldListReward.sort()) !== JSON.stringify(this.formUpdate.listReward.sort())
              if (this.isDifferent) {
                this.listNewReward = this.reward.filter(item => this.formUpdate.listReward.includes(item.rewardId))
                console.log('this.listNewReward', this.listNewReward)
              } else {
                this.listNewReward = []
              }
            } catch (error) {
              console.log('error', error)
            }
          }
        } else {

        }
      }
      // case สถาพัด
      if (this.isDifferent) {
        this.$swal({
          title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
          html: `
            <b {} style="color: red;">คุณได้แก้ไขของรางวัลใหม่ ${this.listNewReward.length} รางวัล</b><br/>
            <div style="display: flex; justify-content: center; width: 100%; text-align: left;">
              ${this.listNewReward.map(item => `<span class="mr-3"> - ${item.name}</span>`).join('')}
            </div>
            <b style="color: red;">ระบบจะทำการเพิ่มของรางวัลไปยังสมาชิกที่ซื้อแพ็กเกจนี้</b>
          `,
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async (result) => {
            this.loadingEdit = true
            this.formUpdate.LAST_USER = this.session.data.userName
            var ID = this.formUpdate.packageId
            if (this.filesUpdate) {
              const _this = this
              let params = new FormData()
              params.append('file', this.filesUpdate)
              await axios
                .post(this.DNS_IP + `/file/upload/package`, params)
                .then(function (response) {
                  _this.formUpdate.packageImg = response.data
                  console.log('url Pic', response.data)
                })
            } else {
              this.formUpdate.packageImg = this.formUpdate.pictureUrlPreview
            }
            this.formUpdate.flowId =
              this.formUpdate.flowId.length > 0
                ? this.formUpdate.flowId.filter((item) => item !== '').join(',')
                : ''

            delete this.formUpdate['pictureUrlPreview']
            delete this.formUpdate['packageId']
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['CREATE_USER']
            delete this.formUpdate['packageExpridate']
            console.log('this.formUpdate', this.formUpdate)
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + this.path + "edit/" + ID,
                this.formUpdate
              )
              .then(async (response) => {
                // Debug response
                await this.upDateNewRewar(ID)
                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogEdit = false
                // Load Data
                // await this.reloadData()
                this.filesUpdate = null
                await this.getDataGlobal(
                  this.DNS_IP,
                  this.path,
                  this.session.data.shopId,
                  this.returnLink
                )
                await this.getData()
                this.clearDataUpdate()
                this.loadingEdit = false
              })
              // eslint-disable-next-line handle-callback-err
              .catch((error) => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
              })
          })
          .catch((error) => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      } else {
        this.$swal({
          title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async (result) => {
            this.loadingEdit = true
            this.formUpdate.LAST_USER = this.session.data.userName
            var ID = this.formUpdate.packageId
            if (this.filesUpdate) {
              const _this = this
              let params = new FormData()
              params.append('file', this.filesUpdate)
              await axios
                .post(this.DNS_IP + `/file/upload/package`, params)
                .then(function (response) {
                  _this.formUpdate.packageImg = response.data
                  console.log('url Pic', response.data)
                })
            } else {
              this.formUpdate.packageImg = this.formUpdate.pictureUrlPreview
            }
            if (this.formUpdate.useInBranch) {
              this.formUpdate.useInBranch = this.formUpdate.useInBranch !== '' ? JSON.stringify(this.formUpdate.useInBranch) : this.formUpdate.useInBranch
            }
            if (this.formUpdate.listReward) {
              this.formUpdate.listReward = this.formUpdate.listReward !== '' ? JSON.stringify(this.formUpdate.listReward) : this.formUpdate.listReward
            }
            this.formUpdate.flowId =
              this.formUpdate.flowId.length > 0
                ? this.formUpdate.flowId.filter((item) => item !== '').join(',')
                : ''

            delete this.formUpdate['pictureUrlPreview']
            delete this.formUpdate['packageId']
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['CREATE_USER']
            delete this.formUpdate['packageExpridate']
            console.log('this.formUpdate', this.formUpdate)
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + this.path + "edit/" + ID,
                this.formUpdate
              )
              .then(async (response) => {
                // Debug response
                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogEdit = false
                // Load Data
                // await this.reloadData()
                this.filesUpdate = null
                await this.getDataGlobal(
                  this.DNS_IP,
                  this.path,
                  this.session.data.shopId,
                  this.returnLink
                )
                await this.getData()
                this.clearDataUpdate()
                this.loadingEdit = false
              })
              // eslint-disable-next-line handle-callback-err
              .catch((error) => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
              })
          })
          .catch((error) => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      }
    },
    async upDateNewRewar (ID) {
      let dt = {
        packgeId: ID,
        arrayNewReward: this.listNewReward.map((item) => {
          return item.rewardId
        })
      }
      console.log('dt', dt)
      await axios.post(this.DNS_IP + '/rewardCode/' + 'updateNewReward', dt)
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.packageId)
      this.dataReady = false
      await this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.packageId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async clearData () {
      this.formAdd.packageName = ''
      this.formAdd.packageCount = ''
      this.formAdd.packageImg = ''
      this.formAdd.packagePrice = ''
      this.formAdd.packagePoint = ''
      this.formAdd.packageExpri = ''
      this.formAdd.packageDetail = ''
      this.formAdd.useInBranch = ''
      this.formAdd.flowId = []
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrlPreview = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.filesAdd = null
      this.$refs.form.resetValidation()
      this.dialogAdd = false
      this.formAdd.isCashCoupon = 'False'
      this.formAdd.listReward = null
      this.formAdd.giveRewardStatus = null
    },
    async clearDataUpdate () {
      this.formUpdate.packageId = ''
      this.formUpdate.packageImg = ''
      this.formUpdate.packageName = ''
      this.formUpdate.packageCount = ''
      this.formUpdate.packagePrice = ''
      this.formUpdate.packagePoint = ''
      this.formUpdate.packageExpri = ''
      this.formUpdate.packageDetail = ''
      this.formUpdate.flowId = ''
      this.formUpdate.masBranchID = ''
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      //   this.formUpdate.pictureUrlPreview = ''
      this.formUpdate.shopId = ''
      this.formUpdate.isCashCoupon = 'False'
    },
    async getBranch () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          if (response.data.status !== false) {
            this.branchLoyalty = response.data
            this.branchLoyalty.forEach((item) => {
              this.mapDataBranch[item.masBranchID] = item.masBranchName
            })
            // this.branchLoyalty.unshift({'masBranchName': 'ทุกสาขา', 'masBranchID': 'ทุกสาขา'})
          }
        })
        .catch((error) => {
          console.log('error function getBranchBelink : ', error)
          this.Branch = []
        })
      console.log('this.branchLoyalty', this.branchLoyalty)
      await axios
        .get(
          // eslint-disable-next-line quotes
          "https://api-belinked.betaskthai.tech" +
            '/master_branch/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          console.log('belinkBranch', response)
          if (response.data.status !== false) {
            this.Branch = response.data
              .filter((item) => item.branchId !== 'None')
              .filter((item2) => item2.branchId !== null)
            console.log('this.belinkBranch', this.Branch)
          }
        })
        .catch((error) => {
          console.log('error function getBranchBelink : ', error)
          this.Branch = []
        })
    },
    async checkTel () {
      try {
        const cleanedTel = this.tel_member.split('-').join('').trim()
        const isChubb =
          this.session.data.shopId === this.shopNameData.SHOP_ID_CHUBB
        const ready = isChubb
          ? cleanedTel.length >= 7
          : cleanedTel.length === 10
        if (!ready || cleanedTel === this.lastCheckedTel) {
          return
        }
        this.lastCheckedTel = cleanedTel
        const member = await this.findMemberByTel(cleanedTel)
        if (cleanedTel !== this.lastCheckedTel) {
          return
        }
        if (member) {
          this.foundItem = member
          return
        }
        this.foundItem = []
        this.lastCheckedTel = ''
        this.$swal(
          'ไม่พบบัญชี',
          'กรุณาตรวจสอบหมายเลขโทรศัพท์อีกครั้ง',
          'error'
        )
        this.tel_member = ''
      } catch (error) {
        console.error('checkTel error => ', error)
      }
    },
    cancle () {
      this.dialogSelectMemberSell = false
      this.tel_member = ''
      this.lastCheckedTel = ''
      this.foundItem = []
      // this.$refs.form.reset()
    },
    dataPackage (item) {
      console.log(item)
      this.dataPK.packageName = item.packageName
      this.dataPK.packagePrice = item.packagePrice
      this.dataPK.packageCount = item.packageCount
      this.dataPK.packagePoint = item.packagePoint
      this.dataPK.packageExpridate = item.packageExpridate
      this.dataPK.flowId = item.flowId
      this.dataPK.packageId = item.packageId
      this.dataPK.useInBranch = item.useInBranch
      if (this.dataPK.useInBranch && this.dataPK.useInBranch !== '' && this.dataPK.useInBranch !== 'None' && this.dataPK.useInBranch.length > 0) {
        if (typeof this.dataPK.useInBranch === 'string') {
          this.dataPK.useInBranch = JSON.parse(this.dataPK.useInBranch)
          if (this.dataPK.useInBranch.length > 0) {
            this.dataPK.useInBranch.forEach((item, index) => {
              this.dataPK.useInBranch[index] = this.mapDataBranch[item]
            })
          } else {
            this.dataPK.useInBranch = null
          }
        }
      }
      // this.dataPK = item.packageName
    },
    async submit () {
      if (this.$refs.form.validate()) {
        this.tel_member = this.tel_member.split('-').join('').trim()
        this.loading = true
        if (this.tel_member !== '' && this.tel_member.length === 10) {
          this.LinkPackage()
          this.createQRcodePackage.packageId = this.formUpdate.packageId
          this.createQRcodePackage.CREATE_USER = this.session.data.userName
          this.createQRcodePackage.LAST_USER = this.session.data.userName
          this.createQRcodePackage.liffId = this.liffId
          this.createQRcodePackage.shopId = this.$session.getAll().data.shopId
          this.createQRcodePackage.qrCodeURL = `https://liff.line.me/${this.liffId}/packageQRcode?shopId=${this.createQRcodePackage.shopId}&packageToken=${this.createQRcodePackage.Token}`
          delete this.createQRcodePackage['CREATE_DATE']
          this.createQRcodePackage.status = 'waiting'
          this.createQRcodePackage.packageId = this.dataPK.packageId
          this.createQRcodePackage.memberId = this.foundItem.memberId
          await axios
            .post(this.DNS_IP + '/packageQRcode/add', this.createQRcodePackage)
            .then(async (response) => {
              let res = response.data
              console.log('res', res)
              const body = {
                token: res.token
              }
              await axios
                .post(this.DNS_IP + '/collect_package/edit', body, {
                  headers: {
                    lineId: this.foundItem.liffUserId,
                    memberId: this.createQRcodePackage.memberId,
                    shopId: this.$session.getAll().data.shopId
                  }
                })
                .then((res) => {
                  console.log('reeeeeeee', res)
                  this.$swal('เรียบร้อย', 'เพิ่มแพ็กเกจเรียบร้อย', 'success')
                  this.loading = false
                  this.dialogSelectMemberSell = false
                  this.foundItem = []
                  this.tel_member = ''
                  this.$refs.form.reset()
                })
              this.formAdd.CREATE_DATE = new Date().toISOString().substr(0, 10)
            })
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
            .catch((error) => {
              console.log('error function addData : ', error)
              this.dataReady = true
            })
        } else {
          this.$swal(
            'ไม่สำเร็จ',
            'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก',
            'warning'
          )
          this.tel_member = ''
          this.loading = false
        }
      }
    },
    async submitLmg () {
      if (this.$refs.form.validate()) {
        this.tel_member = this.tel_member.split('-').join('').trim()
        this.loading = true
        if (this.tel_member !== '' && this.tel_member.length === 7) {
          this.LinkPackage()
          this.createQRcodePackage.packageId = this.formUpdate.packageId
          this.createQRcodePackage.CREATE_USER = this.session.data.userName
          this.createQRcodePackage.LAST_USER = this.session.data.userName
          this.createQRcodePackage.liffId = this.liffId
          this.createQRcodePackage.shopId = this.$session.getAll().data.shopId
          this.createQRcodePackage.qrCodeURL = `https://liff.line.me/${this.liffId}/packageQRcode?shopId=${this.createQRcodePackage.shopId}&packageToken=${this.createQRcodePackage.Token}`
          delete this.createQRcodePackage['CREATE_DATE']
          this.createQRcodePackage.status = 'waiting'
          this.createQRcodePackage.packageId = this.dataPK.packageId
          this.createQRcodePackage.memberId = this.foundItem.memberId
          await axios
            .post(this.DNS_IP + '/packageQRcode/add', this.createQRcodePackage)
            .then(async (response) => {
              let res = response.data
              console.log('res', res)
              const body = {
                token: res.token
              }
              await axios
                .post(this.DNS_IP + '/collect_package/edit', body, {
                  headers: {
                    lineId: this.foundItem.liffUserId,
                    memberId: this.createQRcodePackage.memberId,
                    shopId: this.$session.getAll().data.shopId
                  }
                })
                .then((res) => {
                  console.log('reeeeeeee', res)
                  this.$swal('เรียบร้อย', 'เพิ่มแพ็กเกจเรียบร้อย', 'success')
                  this.loading = false
                  this.dialogSelectMemberSell = false
                  this.foundItem = []
                  this.tel_member = ''
                  this.$refs.form.reset()
                })
              this.formAdd.CREATE_DATE = new Date().toISOString().substr(0, 10)
            })
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
            .catch((error) => {
              console.log('error function addData : ', error)
              this.dataReady = true
            })
        } else {
          this.$swal(
            'ไม่สำเร็จ',
            'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก',
            'warning'
          )
          this.tel_member = ''
          this.loading = false
        }
      }
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}
.v-select__selections {
  padding: 10px; /* Adjust the padding value as needed */
}
.v-chip {
  margin-top: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Package.vue